import { useState } from 'react';

import type { Winner } from '@src/@types/ozonPrizeWinners';
import { WINNER_LIST_ANCHOR } from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/constants';
import {
  WINNER_10000_LIST,
  WINNER_20000_LIST,
} from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/OtherWinners/constants';
import { scrollToElementById } from '@src/helpers/common';

export const useWinnersData = () => {
  const [winnerList, setWinnerList] = useState<Winner[]>(WINNER_20000_LIST);

  const isFullListVisible = winnerList.length > WINNER_20000_LIST.length;
  const buttonText = isFullListVisible ? 'Скрыть всех победителей' : 'Показать всех победителей';

  const toggleWinnersList = () => {
    if (isFullListVisible) {
      setWinnerList(WINNER_20000_LIST);
      scrollToElementById(WINNER_LIST_ANCHOR);
    } else {
      setWinnerList(winnerList.concat(WINNER_10000_LIST));
    }
  };

  return { winnerList, isFullListVisible, toggleWinnersList, buttonText };
};
